import { TeachingLanguage } from "@core/shared/types";
import { atom } from "@mongez/react-atom";

type TeachingLanguageAtom = {
  currentLanguage: TeachingLanguage;
  languages: TeachingLanguage[];
};

export const teachingLanguagesAtom = atom<TeachingLanguageAtom>({
  key: "teachingLanguages",
  default: {},
});
